<template>
    <div>
        <el-select
            v-model="form.value"
            :name="form.name"
            clearable
            filterable
            collapse-tags
            :disabled="form.attr && form.attr.disabled ? true : false"
            :placeholder="form.placeholder"
            :size="form.attr ? form.attr.size : ''"
            :fit-input-width="form.attr && form.attr.fitinputwidth ? true : false"
            :placement="form.attr ? form.attr.placement : ''"
            @change="selectAjaxFunction">
            <template v-for="(item, index) in form.options" :key="index">
                <template v-if="typeof(item) == 'string'">
                    <el-option
                        :label="item"
                        :value="index.toString()"
                        :disabled="item.indexOf('disabled:') > -1">
                        <text v-if="item.indexOf('disabled:') > -1">{{ item.slice(9) }}</text>
                        <text v-else>{{ item }}</text>
                    </el-option>
                </template>
                <template v-else>
                    <el-option
                        :label="item[form.config.key]"
                        :value="item[form.config.value]"
                        :disabled="item.disabled">
                        <text v-if="item.title_display" v-html="item.title_display" />
                        <text v-else>{{ item[form.config.key] }}</text>
                    </el-option>
                </template>
            </template>
        </el-select>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, inject, watch } from 'vue'
    import { linkageAjaxRemoteMethod } from '@/utils/function'
    export default defineComponent({
        props: {
            formobj: {
                type: [Array, Object],
                default: () => {}
            },
            forms: {
                type: [Array, Object],
                default: () => {}
            }
        },
        setup(props, context) {
            const form = ref(props.forms)
            const formobj = ref(props.formobj)
            const options = ref(form.value.options)
            const { proxy } = getCurrentInstance()

            const selectAjaxFunction = (query) => {
                let url = form.value.attr.url
                if (!url) {
                    url = form.value.attr.params
                }
                let f = form.value.next_items.split(',')
                f.forEach((t, i) => {
                    for (let fi in formobj.value) {
                        if (formobj.value[fi].name === t) {
                            if (i === 0) {
                                formobj.value[fi].value = ''
                            } else {
                                formobj.value[fi].options = []
                                formobj.value[fi].value = ''
                            }
                        }
                    }
                })
                linkageAjaxRemoteMethod(query, url, proxy).then((data) => {
                    f.forEach((t, i) => {
                        for (let fi in formobj.value) {
                            if (formobj.value[fi].name === t) {
                                if (i === 0) {
                                    formobj.value[fi].options = data
                                }
                            }
                        }
                    })
                })
            }
            return {
                form,
                selectAjaxFunction,
                options
            }
        }
    })
</script>

<style scoped>

</style>
